import {
	myRand,
	kukeej,
	postFetch,
	getFetch,
	captureNSendError,
} from './customLib';
import { getCountryProperty } from './params';

let reloadFlag = true;

const reloadMaadi = () => {
	if (!!reloadFlag) {
		setTimeout(() => {
			reloadFlag = false;
			//  window.location.reload();
		}, 4000);
	}
};

const apiUrl =
	/* process.env.NODE_ENV === 'production'
		? 'https://bitbns.com'
		: */ ''; /* process.env.REACT_APP_API_URL */

export const loginMaadi = params => postFetch(`${apiUrl}/order/login/`, params);

export const registerMaadi = params =>
	postFetch(`${apiUrl}/order/register/`, params);

export const panDetails = params =>
	postFetch(`${apiUrl}/order/addPanDetails/`, params);

export const submitOTP = params =>
	postFetch(`${apiUrl}/order/submitOTPWithIP/`, params);

export const forgotPassOTP = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/forgetPassOTPNew/?rand=${myRand()}`;
	http.open('POST', url, true);

	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 6');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const verifyOTPChangePass = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/verifyOTPChangePass/?rand=${myRand()}`;
	http.open('POST', url, true);

	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 7');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const resendOTP = () => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/resendOTP/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		if (http.readyState === 4) {
			//  console.log(http.responseText.msg);
			if (http.status === 503) {
				reloadMaadi();
				console.log('prob in 7');
			}
			console.log('prob in 8');
		}
	};
	http.send();
};

export const idProofDetails = params =>
	postFetch(`${apiUrl}/order/addEyeDetails/`, params);

// export const idProofDetails = (params, callback) => {
// 	const http = new XMLHttpRequest();
// 	const url = apiUrl + '/order/addEyeDetails/?rand=' + myRand();
// 	http.open('POST', url, true);

// 	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

// 	// Send the proper header information along with the request

// 	http.onreadystatechange = function() {
// 		// Call a function when the state changes.
// 		let message = 'Something went wrong';
// 		if (http.readyState === 4) {
// 			try {
// 				callback(JSON.parse(http.responseText)[0]);
// 			} catch (err) {
// 				if (http.status === 503) {
// 					reloadMaadi();
// 					console.log('prob in 9');
// 				}
// 				callback({ status: -42, msg: message });
// 			}
// 		}
// 	};
// 	http.send(params);
// };

// export const addBankDetails = (params, callback) => {
// 	const http = new XMLHttpRequest();
// 	const url = apiUrl + '/order/addBankDetails/?rand=' + myRand();
// 	http.open('POST', url, true);

// 	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

// 	// Send the proper header information along with the request

// 	http.onreadystatechange = function() {
// 		// Call a function when the state changes.
// 		let message = 'Something went wrong';
// 		if (http.readyState === 4) {
// 			try {
// 				callback(JSON.parse(http.responseText)[0]);
// 			} catch (err) {
// 				if (http.status === 503) {
// 					reloadMaadi();
// 					console.log('prob in 10');
// 				}
// 				callback({ status: -42, msg: message });
// 			}
// 		}
// 	};
// 	http.send(params);
// };

export const addMoreBankDetails = params =>
	postFetch(`${apiUrl}/order/addMoreBankDetails/`, params);
// (params, callback) => {
// 	const http = new XMLHttpRequest();
// 	const url = apiUrl + '/order/addMoreBankDetails/?rand=' + myRand();
// 	http.open('POST', url, true);

// 	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

// 	// Send the proper header information along with the request

// 	http.onreadystatechange = function() {
// 		// Call a function when the state changes.
// 		let message = 'Something went wrong';
// 		if (http.readyState === 4) {
// 			try {
// 				callback(JSON.parse(http.responseText)[0]);
// 			} catch (err) {
// 				if (http.status === 503) {
// 					reloadMaadi();
// 					console.log('prob in 10');
// 				}
// 				callback({ status: -42, msg: message });
// 			}
// 		}
// 	};
// 	http.send(params);
// };

export const getStatus = () => postFetch(`${apiUrl}/order/getStatus/`);

export const isBankAvailable = () =>
	postFetch(`${apiUrl}/order/isBankAvailable/`);

export const updateDone = params =>
	postFetch(`${apiUrl}/order/updateDone/`, params);

// export const updateDone = callback => {
// 	const http = new XMLHttpRequest();
// 	const url = apiUrl + '/order/updateDone/?rand=' + myRand();
// 	http.open('POST', url, true);
// 	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

// 	// Send the proper header information along with the request

// 	http.onreadystatechange = function() {
// 		// Call a function when the state changes.
// 		let message = 'Something went wrong';
// 		if (http.readyState === 4) {
// 			try {
// 				callback(JSON.parse(http.responseText)[0]);
// 			} catch (err) {
// 				if (http.status === 503) {
// 					reloadMaadi();
// 				}
// 				callback({ status: -42, msg: message });
// 			}
// 		}
// 	};
// 	http.send();
// };

export const isLoggedIn = () => getFetch(`${apiUrl}/order/isLoggedIn/`);

export const logoutMaadi = () => getFetch(`${apiUrl}/order/logout/`);

// export const startPan = callback => {
// 	const http = new XMLHttpRequest();
// 	const url = '/startPan/?rand=' + myRand();
// 	http.open('GET', url, true);
// 	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

// 	// Send the proper header information along with the request

// 	http.onreadystatechange = function() {
// 		// Call a function when the state changes.
// 		let message = 'Something went wrong';
// 		if (http.readyState === 4) {
// 			try {
// 				callback(JSON.parse(http.responseText));
// 			} catch (err) {
// 				if (http.status === 503) {
// 					reloadMaadi();
// 				}
// 				callback({ status: -42, msg: message });
// 			}
// 		}
// 	};
// 	http.send();
// };

export const getBalance = () => getFetch(`${apiUrl}/order/getBalance/`);

/* export const getMyUniqueAccount = callback => {
	const http = new XMLHttpRequest();
	const url = apiUrl + '/order/getMyUniqueAccount/?rand=' + myRand();
	http.open('GET', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function() {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send();
}; */

export const withdrawBTC = params =>
	postFetch(`${apiUrl}/order/withdrawBTC2FA/`, params);

export const withdrawINR = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/withdrawINR2FA/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const getAddress = params =>
	postFetch(`${apiUrl}/order/getAddress/`, params);

export const changePassword = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/changePassword/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const updateBankFlag = params =>
	postFetch(`${apiUrl}/order/updateBankFlag/`, params);

export const getSubmittedDetails = () =>
	postFetch(`${apiUrl}/order/getSubmittedDetails/`);

export const getHistory = params =>
	postFetch(`${apiUrl}/order/getHistory/`, params);

export const checkEligiblity = () =>
	postFetch(`${apiUrl}/order/checkEligiblity/`);

export const claimSale = params =>
	postFetch(`${apiUrl}/order/claimSale/`, params);

export const checkFlashSaleStatus = () =>
	postFetch(`${apiUrl}/order/checkSaleStatus/`);

export const sellPlayBTC = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/sellPlayBTCUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/sellPlayBTC/`, params);
	}
};

export const purchasePlayBTC = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/purchasePlayBTCUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/purchasePlayBTC/`, params);
	}
};

export const listOrder = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/listOrderUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/listOrder/`, params);
	}
};

export const listOrderAll = params =>
	postFetch(`${apiUrl}/order/listOrderAll/`, params);

export const cancelOrder = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/cancelOrderUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/cancelOrder/`, params);
	}
};

export const graphData = params => getFetch(`${apiUrl}/graphData/`, params);

export const graphPoints = params =>
	getFetch(`${apiUrl}/order/graphPointsSummary/`, params);

export const getWithdrawalHistory = callback => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/getWithdrawalHistory/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
			}
		}
	};
	http.send();
};

export const cancelWithdraw = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/cancelWithdraw/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const submitREF = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/submitRefNumber/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const getRates = param => {
	let url = `${apiUrl}/order/getTickerAll/?rand=${myRand()}`;

	if (param === 'full') {
		url = `https://bitbns.com/order/getTickerAll/?rand=${myRand()}`;
	}
	return fetch(url, {
		method: 'GET',
		credentials: 'same-origin',
	}).then(
		response => {
			if (!response.ok) {
				console.log('എന്തെരോ എന്തോ!');
				return [{ status: 0, msg: 'Something went wrong.' }];
			}
			return response.json();
		},
		error => {
			console.log('ജബാ യമഹ!', error);
			return [{ status: 0, msg: 'Something went wrong.' }];
		}
	);
};

export const getRatesWithVol = param => {
	let url = `${apiUrl}/order/getTickerWithVolume/?rand=${myRand()}`;

	if (param === 'full') {
		url = `https://bitbns.com/order/getTickerWithVolume/?rand=${myRand()}`;
	}

	return fetch(url, {
		method: 'GET',
		credentials: 'same-origin',
	}).then(
		response => {
			if (!response.ok) {
				console.log('എന്തെരോ എന്തോ!');
				return [{ status: 0, msg: 'Something went wrong.' }];
			}
			return response.json();
		},
		error => {
			console.log('ജബാ യമഹ!', error);
			return [{ status: 0, msg: 'Something went wrong.' }];
		}
	);
};

export const getRatesWithVolTRY = param => {
	let url = `${apiUrl}/order/getTickerWithVolumeTRY/?rand=${myRand()}`;

	if (param === 'full') {
		url = `https://bitbns.com/order/getTickerWithVolumeTRY/?rand=${myRand()}`;
	}

	return fetch(url, {
		method: 'GET',
		credentials: 'same-origin',
	}).then(
		response => {
			if (!response.ok) {
				console.log('എന്തെരോ എന്തോ!');
				return [{ status: 0, msg: 'Something went wrong.' }];
			}
			return response.json();
		},
		error => {
			console.log('ജബാ യമഹ!', error);
			return [{ status: 0, msg: 'Something went wrong.' }];
		}
	);
};

export const start2FA = () => postFetch(`${apiUrl}/order/start2FA/`);

export const submitAndGetKey2FA = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/submitAndGetKey2FA/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const submitAndEnable2FA = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/submitAndEnable2FA/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const submit2FAOTP = params =>
	postFetch(`${apiUrl}/order/submit2FAOTPWithIP/`, params);

export const disable2FAOTP = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/disable2FAOTP/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const getHistoryAdv = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/getHistoryAdvUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/getHistoryAdv/`, params);
	}
};

export const getWithdrawalHistoryCoin = params =>
	postFetch(`${apiUrl}/order/getWithdrawalHistoryCoin/`, params);

export const getWithdrawalHistoryINR = () =>
	postFetch(`${apiUrl}/order/getWithdrawalHistoryINR/`);

export const getDepositHistoryCoin = params =>
	postFetch(`${apiUrl}/order/getDepositHistoryCoin/`, params);

export const resendMail = params =>
	postFetch(`${apiUrl}/order/resendMail/`, params);

export const getMyReferralID = () =>
	getFetch(`${apiUrl}/order/getMyReferralID/`);

export const purchaseStopLossBTC = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(
				`${apiUrl}/order/purchaseStopLossBTCUSDT/`,
				params
			);

		default:
			return postFetch(`${apiUrl}/order/purchaseStopLossBTC/`, params);
	}
};

export const sellStopLossBTC = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/sellStopLossBTCUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/sellStopLossBTC/`, params);
	}
};

export const cancelStopLossOrder = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(
				`${apiUrl}/order/cancelStopLossOrderUSDT/`,
				params
			);

		default:
			return postFetch(`${apiUrl}/order/cancelStopLossOrder/`, params);
	}
};

export const listStopLossOrder = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/listStopLossOrderUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/listStopLossOrder/`, params);
	}
};

/**
 *
 * 	Margin trading
 */

export const lendBorrowPlayBTC = params =>
	postFetch(`${apiUrl}/order/lendBorrowPlayBTCAllMultiple`, params);

export const listMarginPendingOrder = params =>
	postFetch(`${apiUrl}/order/listMarginPendingOrder`, params);

export const cancelMTOrder = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/cancelMTOrderNew/?rand=${myRand()}`;
	http.open('POST', url, true);
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	// Send the proper header information along with the request

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};
export const listMarginExecutedOrder = params =>
	postFetch(`${apiUrl}/order/listMarginExecutedOrder`, params);

export const getLoanAbleCoin = params =>
	getFetch(`${apiUrl}/order/getLoanAbleCoin/`, params);

export const getMinMTradeAmount = params =>
	getFetch(`${apiUrl}/order/getMinTradeAmount/`, params);

export const getMarginGraph = params =>
	postFetch(`${apiUrl}/order/getMarginGraph/`, params);

export const listLendingOrder = params =>
	postFetch(`${apiUrl}/order/listLendingOrder/`, params);

export const updateRenewStatusMT = params =>
	postFetch(`${apiUrl}/order/updateRenewStatusMT/`, params);

export const settleMTOrder = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/settleMTOrder/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const getReport = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/getReport/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};
/**
 * 	Price Alerts:
 **/

export const setPriceAlert = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/setPriceAlertUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/setPriceAlert/`, params);
	}
};

export const cancelPriceAlert = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/cancelPriceAlertUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/cancelPriceAlert/`, params);
	}
};

export const listPriceAlert = market_id => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/listPriceAlertUSDT/`);

		default:
			return postFetch(`${apiUrl}/order/listPriceAlert/`);
	}
};

export const buyRAM = params => postFetch(`${apiUrl}/order/buyRAM/`, params);

export const sellRAM = params => postFetch(`${apiUrl}/order/sellRAM/`, params);

/************************ p2p payments */

export const withdrawPeerINR = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/withdrawPeerINR/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const depositPeerINR = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/depositPeerINR/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const listPeerINR = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/listPeerINR/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const detailedPeerStatus = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/detailedPeerStatus/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const detailedPeerStatusArray = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/detailedPeerStatusArray/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const addUPI = params => postFetch(`${apiUrl}/order/addUPI/`, params);

export const withdrawDetails = () =>
	postFetch(`${apiUrl}/order/withdrawDetails/`);

export const depositDetails = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/depositDetails/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const submitRating = params =>
	postFetch(`${apiUrl}/order/submitRating/`, params);

export const submitRefPeer = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/submitRefPeer/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const updateStatus = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/updateStatus/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const cancelPeerDeposit = params =>
	postFetch(`${apiUrl}/order/cancelPeerDeposit/`, params);

export const cancelUnallocatedPeerDeposit = params =>
	postFetch(`${apiUrl}/order/cancelUnallocatedPeerDeposit/`, params);

export const updateExpiryTimePeer = params =>
	postFetch(`${apiUrl}/order/updateExpiryTimePeer/`, params);

export const getRecipientEmail = () =>
	postFetch(`${apiUrl}/order/getRecipientEmail/`);

export const withdrawPeerINRNew = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/withdrawPeerINRNew/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const depositPeerINRNew = params =>
	postFetch(`${apiUrl}/order/depositPeerINRNew/`, params);

export const depositPeerINRInstant = params =>
	postFetch(`${apiUrl}/order/depositPeerINRInstant/`, params);

export const depositPeerINRSelectNew = params =>
	postFetch(`${apiUrl}/order/depositPeerINRSelectNew/`, params);

export const listPeerINRNew = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/listPeerINRNew/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const detailedPeerStatusNew = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/detailedPeerStatusNew/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const detailedPeerStatusArrayNew = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/detailedPeerStatusArrayNew/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const withdrawDetailsNew = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/withdrawDetailsNew/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const depositDetailsNew = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/depositDetailsNew/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const submitRatingNew = params =>
	postFetch(`${apiUrl}/order/submitRatingNew/`, params);

export const submitRefPeerNew = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/submitRefPeerNew/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const updateStatusNew = (params, callback) => {
	const http = new XMLHttpRequest();
	const url = `${apiUrl}/order/updateStatusNew/?rand=${myRand()}`;
	http.open('POST', url, true);

	// Send the proper header information along with the request
	http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

	http.onreadystatechange = function () {
		// Call a function when the state changes.
		let message = 'Something went wrong';
		if (http.readyState === 4) {
			try {
				callback(JSON.parse(http.responseText)[0]);
			} catch (err) {
				if (http.status === 503) {
					reloadMaadi();
					console.log('prob in 1');
				}
				callback({ status: -42, msg: message });
			}
		}
	};
	http.send(params);
};

export const cancelPeerDepositNew = params =>
	postFetch(`${apiUrl}/order/cancelPeerDepositNew/`, params);

export const cancelUnallocatedPeerDepositNew = params =>
	postFetch(`${apiUrl}/order/cancelUnallocatedPeerDepositNew/`, params);

export const updateExpiryTimePeerNew = params =>
	postFetch(`${apiUrl}/order/updateExpiryTimePeerNew/`, params);

export const updateTip = params =>
	postFetch(`${apiUrl}/order/updateTip/`, params);

export const getWithList = () => postFetch(`${apiUrl}/order/getWithList/`);

export const cancelWithdrawPeerNew = params =>
	postFetch(`${apiUrl}/order/cancelWithdrawPeerNew/`, params);

export const cancelWithdrawPeer = params =>
	postFetch(`${apiUrl}/order/cancelWithdrawPeer/`, params);

export const updatePreferredUser = params =>
	postFetch(`${apiUrl}/order/updatePreferredUser2FA/`, params);

/************************ Premium Deposits ***/

export const requestPremiumDeposit = () =>
	postFetch(`${apiUrl}/order/requestPremiumDeposit/`);

export const getPremiumDepositStatus = () =>
	postFetch(`${apiUrl}/order/getPremiumDepositStatus/`);

export const getBankDetailsPremium = () =>
	postFetch(`${apiUrl}/order/getBankDetailsPremium/`);

export const submitRefPremium = params =>
	postFetch(`${apiUrl}/order/submitRefPremium/`, params);

/**
 *
 * API TRADING
 *
 * 	1: /order/listKeysAvailable/
 *    no params
 *
 *	2: /order/generateKey/
 *    no params
 *
 *  3: /order/revokeKey/
 * 	params - pubKey
 *
 * */

export const listKeysAvailable = () =>
	postFetch(`${apiUrl}/order/listKeysAvailable/`);

export const generateKey = () => postFetch(`${apiUrl}/order/generateKey/`);

export const revokeKey = params =>
	postFetch(`${apiUrl}/order/revokeKey/`, params);

/***
 * Bracket Orders:
 */

export const purchasePlayBTCBracket = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(
				`${apiUrl}/order/purchasePlayBTCBracketUSDT/`,
				params
			);

		default:
			return postFetch(`${apiUrl}/order/purchasePlayBTCBracket/`, params);
	}
};

/**
 * params: quantity, rate, target_rate, stop_rate, trail, coin
 */

export const sellPlayBTCBracket = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/sellPlayBTCBracketUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/sellPlayBTCBracket/`, params);
	}
};
/**
 * params: quantity, rate, target_rate, stop_rate, trail, coin
 */

export const listBracketOrder = (params, market_id) => {
	switch (market_id) {
		case 1:
			return postFetch(`${apiUrl}/order/listBracketOrderUSDT/`, params);

		default:
			return postFetch(`${apiUrl}/order/listBracketOrder/`, params);
	}
};

/**
 * params: coin, page
 */

/**
 * log out all devices:
 */

export const logoutAllDevices = () =>
	postFetch(`${apiUrl}/order/logoutAllDevices/`);

export const listLeaders = () => getFetch(`${apiUrl}/order/listLeaders/`);

export const listLeadersAll = () =>
	postFetch(`${apiUrl}/order/listLeadersAll/`);

/**
 * P2P USDT:
 */

/**
 * Sell USDT:
 * @param {number} amount Amount to be withdrawn
 * @param {number} rate Amount to be withdrawn
 * @param {number} otp
 * @description Withdraw USDT API
 */
export const withdrawPeerUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/withdrawPeerUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/withdrawPeerUSDT/`, params);
};

/**
 * Buy USDT:
 * @param {number} amount Amount to be deposited
 * @param {number} rate Amount to be deposited
 * @description Deposit USDT API
 */
export const depositPeerUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/depositPeerUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/depositPeerUSDT/`, params);
};

/**
 * Instant Buy USDT:
 * @param {number} amount Amount to be deposited
 * @param {number} rate Amount to be deposited
 * @description Instant Deposit USDT API
 */
export const depositPeerUSDTInstant = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/depositPeerUSDTInstantOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(
		`${apiUrl}/order/depositPeerUSDTInstant/`,
		`${params}&market=${id}`
	);
};

/**
 * Cancel Sell USDT:
 * @param {number} id Id to be order
 * @description Cancel Sell USDT
 */
export const cancelWithdrawPeerUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/cancelWithdrawPeerUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/cancelWithdrawPeerUSDT/`, params);
};

/**
 * Cancel Buy USDT:
 * @param {number} id Id to be order
 * @description Cancel Buy USDT
 */
export const cancelDepositPeerUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/cancelDepositPeerUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/cancelDepositPeerUSDT/`, params);
};

/**
 * Cancel Matched deposit Order:
 * @param {number} id Id to be order
 * @description Cancel Matched deposit Order
 */
export const cancelDepositMatchedPeerUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/cancelDepositMatchedPeerUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/cancelDepositMatchedPeerUSDT/`, params);
};

/**
 * @param {number} type 0: deposit, 1: withdraw
 * @param {number} page Page to be shown
 * @description List Peers
 */
export const listPeerUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/listPeerUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/listPeerUSDT/`, params);
};

/**
 * @param {number} type 0: deposit, 1: withdraw
 * @param {number} ids Ids of the List Item
 * @description Get list of all peers within a tx
 */
export const detailedPeerUSDTStatusArray = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/detailedPeerUSDTStatusArrayOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/detailedPeerUSDTStatusArray/`, params);
};

/**
 * @param {number} id ref_id
 * @description Get Deposit Details
 */
export const depositDetailsUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/depositDetailsUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/depositDetailsUSDT/`, params);
};

/**
 * @param {number} type 0: deposit, 1: withdraw
 * @param {number} rate rating from 1 to 5
 * @param {number} id Id of the detailed peer
 * @description Submit rating for the p2p tx
 */
export const submitRatingUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/submitRatingUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/submitRatingUSDT/`, params);
};

/**
 * @param {number} type 0: deposit, 1: withdraw
 * @param {number} ref reference number of the tx
 * @param {string} statement comments for the tx
 * @description submit reference number for the tx
 */
export const submitRefPeerUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/submitRefPeerUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/submitRefPeerUSDT/`, params);
};

/**
 * @param {number} id ref_id
 * @param {number} status status updation for the peer tx
 * @description update the status for dispute, confirmation etc of the tx
 */
export const updateStatusUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/updateStatusUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/updateStatusUSDT/`, params);
};

/**
 * @param {number} id Id of the peer
 * @description Extend updation timem for p2p tx
 */
export const updateExpiryTimePeerUSDT = (params, market) => {
	const id = getCountryProperty(market, 'id');

	if (id > 0) {
		return postFetch(
			`${apiUrl}/order/updateExpiryTimePeerUSDTOthers/`,
			`${params}&market=${id}`
		);
	}
	return postFetch(`${apiUrl}/order/updateExpiryTimePeerUSDT/`, params);
};

/**
 * use proofus maximus
 * @param {number} id Id of the peer
 * @param {string} videoDisputeUSDT
 * @description use proofus maximus
 */

/**
 * coin withdrawal n deposit status update
 */

export const disabledCoins = () =>
	getFetch(`${apiUrl}/jugApi/disabledConfig.json`);

export const bhMonitor = params =>
	fetch('https://buyhatke.com/monitor/', {
		method: 'POST',
		body: params,
		headers: new Headers({
			'Content-type': 'application/json',
			'Cache-Control': 'no-store',
			Pragma: 'no-store',
		}),
	}).then(
		response => {
			if (!response.ok) {
				console.log('എന്തെരോ എന്തോ!');
				return { status: 0, msg: 'Something went wrong.' };
			}
			return response.json();
		},
		error => {
			console.log('ജബാ യമഹ!', error);
			return { status: 0, msg: 'Something went wrong.' };
		}
	);

export const getSideNotifs = () =>
	getFetch(`${apiUrl}/jugApi/globalNotifs.json`);

// export const getAnnouncements = () =>
// 	getFetch(apiUrl + '/jugApi/announcements.json');

// export const getHeaderUpdates = () =>
// 	getFetch(apiUrl + '/jugApi/headerUpdates.json');

export const getContestData = () => getFetch(`${apiUrl}/jugApi/contests.json`);

export const listNotifications = () =>
	postFetch(`${apiUrl}/order/listNotifications/`);

export const flushNotifications = () =>
	postFetch(`${apiUrl}/order/flushNotifications/`);

export const getAllUSDTINR = params =>
	getFetch(`${apiUrl}/order/getAllUSDTINR/`, params);

export const depositPeerUSDTPreferredOthers = params =>
	postFetch(`${apiUrl}/order/depositPeerUSDTPreferredOthers/`, params);

export const withdrawPeerUSDTPreferredOthers = params =>
	postFetch(`${apiUrl}/order/withdrawPeerUSDTPreferredOthers/`, params);

export const setUserName = params =>
	postFetch(`${apiUrl}/order/setUserName/`, params);

export const getUserName = () => getFetch(`${apiUrl}/order/getUserName/`);

export const getmaxTipPossible = () =>
	getFetch(`${apiUrl}/order/getmaxTipPossible/`);

export const actionsRequired = () =>
	getFetch(`${apiUrl}/order/actionsRequired/`);

export const getAllUSDTPrices = () =>
	getFetch(`${apiUrl}/order/getAllUSDTPrices/`);

export const slabsList = param => {
	let url = `${apiUrl}/jugApi/feeSlabs.json`;

	if (param === 'full') {
		url = 'https://bitbns.com/jugApi/feeSlabs.json';
	}
	return getFetch(url);
};

export const allDynamicFee = param => {
	let url = `${apiUrl}/order/allDynamicFee`;

	if (param === 'full') {
		url = 'https://bitbns.com/order/allDynamicFee';
	}
	return getFetch(url);
};

export const getMyReferralStats = () =>
	getFetch(`${apiUrl}/order/getMyReferralStats`);

export const setSessionLanding = params =>
	postFetch('/order/setSessionLanding/', params);

// export * from './dummyCred';

export const getOTPToken = () => getFetch(`${apiUrl}/order/getOTPToken`);

export const getMyIPDetails = () =>
	fetch(`${apiUrl}/order/getMyIPDetails`, {
		method: 'GET',
		credentials: 'include',
		cache: 'no-cache',
		headers: new Headers({
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		}),
	})
		.then(
			response => {
				if (!response.ok) {
					console.log(
						'Happy Diwali! API phat gayi:',
						'getMyIPDetails'
					);
					return { status: 0, msg: 'Something went wrong.' };
				}
				return response.json();
			},
			error => {
				console.log(
					'Kuch to gadbad hai daya:',
					'getMyIPDetails',
					error
				);
				captureNSendError(error);
				return { status: 0, msg: 'Something went wrong.' };
			}
		)
		.catch(error => {
			console.log('Kuch to gadbad hai daya:', 'getMyIPDetails', error);
			captureNSendError(error);
			return { status: 0, msg: 'Something went wrong.' };
		});
